import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{ alternativeAddressId?: string }>;

export const DispatchSetAlternativeAddress: HandlerType = props => {
    props.dispatch({
        type: "Shipping/SetAlternativeAddress",
        alternativeAddressId: props.parameter.alternativeAddressId,
    });
};

export const chain = [DispatchSetAlternativeAddress];

const setAlternativeAddress = createHandlerChainRunner(chain, "SetAlternativeAddress");
export default setAlternativeAddress;
